// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader__header--2RR","info":"MobileHeader__info--1n2","menu":"MobileHeader__menu--2Us","controls":"MobileHeader__controls--wrQ"};